import { render, staticRenderFns } from "./DetailsBox.vue?vue&type=template&id=5d8c1fe3&"
import script from "./DetailsBox.vue?vue&type=script&lang=js&"
export * from "./DetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports